export const ABOUT = 'https://go.edmodo.com/sobre-edmodo/'

export const CAREERS = 'https://go.edmodo.com/careers/"'

export const PRIVACY = 'https://go.edmodo.com/privacy-policy/'

export const TERMS_OF_SERVICE = 'https://go.edmodo.com/terms-of-service/'

export const CONTACT_OF_US = 'https://go.edmodo.com/contact/'

export const TEACHERS = 'https://go.edmodo.com/teachers/'

export const STUDENTS = 'https://go.edmodo.com/students/'

export const PARENTS = 'https://go.edmodo.com/parents/'

export const SCHOOLS = 'https://go.edmodo.com/schools/'

export const SPOTLIGHT = 'http://spotlight.edmodo.com'

export const BLOG = 'https://medium.com/edmodoblog'

export const SUPPORT = 'http://support.edmodo.com'

export const TWITTER = 'http://twitter.com/edmodo'

export const FACEBOOK = 'http://www.facebook.com/edmodo/'

export const FEEDBACK = 'https://support.edmodo.com/hc/en-us/requests/new?ticket_form_id=360001309214'

export const EDMODO = 'https://www.edmodo.com'

export const EDMODO_BLOG = 'https://new.edmodo.com/pages/edmodolabs'

export const EDMODO_SIGN_UP = 'https://new.edmodo.com'

export const EDMODO_SWITCH_ACCOUNT = 'https://api.edmodo.com/login'



// WEBPACK FOOTER //
// ./src/constants/edmodo.js